<div class="placeholders">
    <fui-alerts></fui-alerts>
</div>

<wbo-login-podium>
    <div class="signin">
        <div class="signin-header">
            <div class="signin-header-media">
                <div class="signin-header-media-object">
                    <fui-pos-logo id="logo" [type]="'fedelta'"></fui-pos-logo>
                </div>
            </div>
        </div>

    </div>
</wbo-login-podium>
